// -*- Mode: rjsx -*-
import React from 'react';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import { useSelector } from 'react-redux';

// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { CSSTransitionGroup } from 'react-transition-group';


// FIXME: move all these...
import FancyDate from '../../../ui/FancyDate';
import { AvatarSig } from '../../../ui/Avatar';
import { ChatMessage } from '../../../containers/ChatContainer';
import FancyActionTypes from '../../../data/FancyActionTypes';

class ClaimFlag extends React.Component {
    render() {
	    let request = this.props.request;
	    if (!request.claimed_by)
	        return null;
	    if (request.claimed_by.key !== window.pageVariables.user_key)
	        return null;

	    let yourTaskStyle = {
	        backgroundColor: "#eb6666",
	        color: "white",
	        width: "100%",
	        textAlign: "center",
	        paddingBottom: 3,
	        marginBottom: 3
	    };
	    return (
	        <div style={yourTaskStyle}>
	          Your request
	        </div>
	    );
    }
}


class ODOFlag extends React.Component {
    render() {
	    let request = this.props.request;
	    if(!request.odo)
	        return null;
	    let maxBonus = '';
	    let style = {
	        right: {
		        'float': 'right'
	        },
	        small: {
		        'fontSize': '80%'
	        }
	    };
	    if (request.odo_max_bonus) {
	        maxBonus = (
		        <span className='max-bonus'
		              style={style.right}><span style={style.small}>MAX BONUS:</span>
		          <strong>
		            &nbsp;{request.odo_max_bonus}
		          </strong>
		        </span>
	        );
	    }
	    return (
	        <div>
	          <img src='/images/odo-mini.png' />
	          { maxBonus }
	        </div>
	    );
    }
}

class CardRequestLink extends React.Component {
    render() {
	    let request = this.props.request;
	    let style = {
	        backgroundColor: "#EFEFEF",
	        borderBottom: "2px solid #DAD9D9",
	        fontWeight: "bold",
	        padding: "5px 7px",
	        marginTop: 5,
	        color: "black",
	        borderRadius: 3
	    };
	    if(request.odo && !request.claimed_by) {
	        return <a href={request.url} style={style}>Claim Now</a>;
	    }
	    return (
	        <a href={request.url} style={style}>Take a Look</a>
	    );
	    
    }
}

class ChatAvatar extends React.Component {
    render() {
	    let request = this.props.request;
	    
	    if (request.odo) {
	        return null;
	    }
	    
	    let style = {
	        height: 50,
	        display: "table-cell",
	        verticalAlign: "top"		
	    };
	    
	    
	    return (
    	    <div style={style}>
	          <img src={request.user.avatar_url} width={50} />
	        </div>
	    );
    }

}

/* move to UI */
class RequestCard extends React.Component {
    render() {
	    let styleRequestCard = {
	        backgroundColor: "white",
	        borderRadius: 1,
	        border: "solid 1px #ddd",
	        borderBottom: "solid 4px #ddd",
	        padding: 3,
	        transition: "0.3s",

	        content: {
		        paddingLeft: 3,
		        paddingRight: 3,		
		        display: "table-cell",
		        verticalAlign: "top",
		        maxWidth: "300px"
	        },
	        actions: {
		        // paddingLeft: 3,
		        // paddingRight: 3,		
		        // display: "table-cell",
		        textAlign: "right",
		        margin: "3px 3px 10px 3px"
	        }	    
	    };

	    let request = this.props.request;
	    if(!request)
	        return null;
	    
	    return (
	        <div style={styleRequestCard}>
	          <ClaimFlag request={request} />
	          <ODOFlag request={request} />
	          <ChatAvatar request={request} />
	          <div style={styleRequestCard.content}>	      
		        <strong>{request.title}</strong> <br />
		        {request.user_display_name}
	          </div>
	          <div style={styleRequestCard.actions}>
		        <CardRequestLink request={request} />
	          </div>
	        </div>
	    );
    }
}



class NotificationMessageFrom extends React.Component {
    render() {
	    let styleFrom = {
	        color: "darkgrey"
	    };

	    if(!this.props.from)
	        return null;
	    else
	        return (
		        <div style={styleFrom}>
		        </div>
	        );
    }
}


class NotificationMessageDate extends React.Component {
    render() {
	    let styleDate = {
	        color: "darkgrey"
	        
	    };

	    if(!this.props.date)
	        return null;
	    else
	        return (
		        <div style={styleDate}>
		          <FancyDate date={this.props.date} />
		        </div>
	        );
    }
}

class NotificationForumContent extends React.Component {
    render() {
	    let title = this.props.title;
	    let url = this.props.url;	
	    let body = this.props.body;
	    let from = this.props.from;	
	    let LIMIT = 140;
	    if(body.length > LIMIT)
	        body = body.substring(0, LIMIT) + "...";

	    let style = {
	        content: {
		        backgroundColor: "white",
		        padding: 3
	        }
	    };
	    return (
	        <div style={style.content}>
	          <strong><a href={url}>{title}</a></strong> <br />
	          {body}
	          <AvatarSig user={from} />
	        </div>
	    );
    }
}

class NotificationForumComment extends React.Component {
    render() {
	    let message = this.props.message;
	    let style = this.props.style;
	    return (
	        <div>
	          <div style={style.bodyText}>New forum comment</div>
	          <NotificationForumContent title={"Re: " + message.payload.title} body={message.payload.body} url={message.payload.url} from={message.from} />
	        </div>
	    );
    }
}

class NotificationForumPost extends React.Component {
    render() {
	    let message = this.props.message;
	    let style = this.props.style;
	    return (
	        <div>
	          <div style={style.bodyText}>{message.body}</div>
	          <NotificationForumContent title={message.payload.title} body={message.payload.body} url={message.payload.url} from={message.from} />
	        </div>
	    );
    }
}

class QuizUpdate extends React.Component {
    render() {
	    let message = this.props.message;
	    let style = this.props.style;
	    return (
	        <div>
	          <div style={style.bodyText}>{message.body}</div>
	          <div>
		        Project: <strong>{message.payload.project.name}</strong> <br />
		        <AvatarSig user={message.from} />
	          </div>
	        </div>
	    );
    }
}


class NotificationChatMessage extends React.Component {
    render() {
	    let notification = this.props.message;
	    let style = this.props.style;

	    style['foot'] = {
	        clear: "all",
	        display: "block",
	        borderTop: "solid 1px #dfdfdf",
	        marginTop: 20
	    };
	    return (
	        <div>
	          <ChatMessage message={notification.payload} hideDate={true}/>
	          <div style={style.foot}>
		        <a href={"/admin/project/" + notification.payload.channel}>Go To Project</a>
	          </div>
	        </div>
	    );
    }
}


class NotificationContent extends React.Component {
    render() {
	    let style = {
	        bodyText: {
		        paddingBottom: 5
	        }
	    };
	    
	    let message = this.props.message;

	    switch (message.type) {
	    case FancyActionTypes.NOTIFICATION_FORUM_COMMENT:
	        return <NotificationForumComment style={style} message={message} />;
	    case FancyActionTypes.NOTIFICATION_FORUM_POST:
	        return <NotificationForumPost style={style} message={message} />;


	    case FancyActionTypes.NOTIFICATION_QUIZ_UPDATED: 
	    case FancyActionTypes.NOTIFICATION_QUIZ_ACTIVATED: 
	    case FancyActionTypes.NOTIFICATION_QUIZ_PASSED: 
	    case FancyActionTypes.NOTIFICATION_QUIZ_FAILED:
	        return <QuizUpdate style={style} message={message} />;

	    case FancyActionTypes.CHAT_ADD:
	        return <NotificationChatMessage style={style} message={message} />;	    
	    default:
	        return (
		        <div>
		          <div style={style.bodyText}>{message.body}</div>
		          <RequestCard request={message.request} />
		        </div>
	        );
	    }
	    
	    
    }
}


class NotificationMessage extends React.Component {
    render() {
	    
	    let style = {
	        message: {
		        backgroundColor: "#f2f2f2",
		        padding: 6,
		        borderTop: "solid 1px #ddd",
		        transition: "opacity 500ms ease-in"
	        },
	        header: {
		        paddingBottom: 3
	        },
	        footer: {
		        paddingTop: 3,
		        paddingBottom: 3		
	        }
	        
	    };

	    let message = this.props.message;
	    if(message.type) {
	        switch(message.type) {
	        case FancyActionTypes.NOTIFICATION_REQUEST_AVAILABLE:
	        case FancyActionTypes.NOTIFICATION_REQUEST_EXISTS:
		        style.message.backgroundColor = "#ecf9f2"; 
		        style.message.borderTop = "solid 1px #6BDE9E";
		        break;		
	        case FancyActionTypes.NOTIFICATION_MENTOR_REQUEST_AVAILABLE:
		        style.message.backgroundColor = "#ffffee"; 
		        style.message.borderTop = "solid 1px #eab43c";
		        break;
	        case FancyActionTypes.NOTIFICATION_REQUEST_LIVE:
		        style.message.backgroundColor = "rgb(230, 224, 255)";
		        style.message.borderTop = "solid 1px rgb(186, 186, 243)";
		        break;
	        case FancyActionTypes.NOTIFICATION_FORUM_COMMENT:
	        case FancyActionTypes.NOTIFICATION_FORUM_POST:
	    	    style.message.backgroundColor = "#f6f8ff";
	    	    style.message.borderTop = "solid 1px rgb(126, 135, 176)";
	    	    break;

	        case FancyActionTypes.NOTIFICATION_QUIZ_UPDATED: 
	        case FancyActionTypes.NOTIFICATION_QUIZ_ACTIVATED: 
	        case FancyActionTypes.NOTIFICATION_QUIZ_DEACTIVATED: 
	        case FancyActionTypes.NOTIFICATION_QUIZ_PASSED: 
	        case FancyActionTypes.NOTIFICATION_QUIZ_FAILED:
	    	    style.message.backgroundColor = "#f6f8ff";
	    	    style.message.borderTop = "solid 1px rgb(126, 135, 176)";
	    	    break;
		        
	        case FancyActionTypes.CHAT_ADD:
	    	    style.message.backgroundColor = "white";
	    	    style.message.borderTop = "solid 1px rgb(126, 135, 176)";
	    	    break;

	        }
	    }
	    
	    return (
	        <div style={style.message}>
	          <div style={style.header}>
		        <NotificationMessageFrom from={message.from} />
	          </div>
	          <div style={style.body}>
		        <NotificationContent message={message} />
	          </div>
	          <div style={style.footer}>
		        <NotificationMessageDate date={message.date} />
	          </div>
	          
	        </div>
	    );
    };
}

export function Notification(props) {

	let messages = useSelector((state) => { return state.notifications.notifications || []; });
//	console.log("state: %o", state);
    console.log("notification.messages: %o", messages);
	let style = {
	    container: {
		    background: 'transparent'
	    },
	    controls: {
		    textAlign: "right",
		    a: {
		        fontWeight: "bold",
		        color: "white",
		        backgroundColor: "#666",
		        borderRadius: 2,
		        margin: 3,
		        padding: 3
		    }
	    }
	};
	
	if (!messages.length)
	    messages = [];
	
    
	if (!messages.length)
	    return null;
    
	return (
	    <div style={style.container}>
	      <div id="notification-stream">
		        <CSSTransitionGroup transitionName="message"
				                    transitionEnterTimeout={500}
				                    transitionLeaveTimeout={300}>
		          { messages.map(message => <NotificationMessage key={message.key} message={message} />) }
	            </CSSTransitionGroup>
	      </div>
	    </div>
	);
}


// function getCurrentMessages(messages) {
//     /* if we're not looking at a specific request, we dont' need to filter any */
//     if(!window.pageVariables.request_key)
// 	    return messages;

//     // don't show notifications for the current request in the notifications bar
//     return messages.filter(m =>(!m.request || (m.request && m.request.key !== window.pageVariables.request_key)));
    
// }

// const mapStateToProps = (state, own) => {
//     return {
// 	    messages: getCurrentMessages(state.notifications.messages)
//     };
// };

// const mapDispatchToProps = dispatch => ({
//     actions: bindActionCreators(FancyActionTypes, dispatch)
// });

// export default connect(mapStateToProps)(Notification);
